import { FormInstance } from 'antd';
import { createContext, useContext } from 'react';
import { ICheckout, ICheckoutInstallment, ICheckoutItem } from '../../interfaces/ICheckout';
import { ICoupon } from '../../interfaces/ICoupon';
import { ICustomer } from '../../interfaces/ICustomer';
import { ITransaction } from '../../interfaces/ITransaction';

type FormContext = {
  checkout: ICheckout;
  isLoading?: boolean;
  form: FormInstance;
  isPaying?: boolean;
  modeAs: 'checkout' | 'transaction' | 'preview';
  items: ICheckout['items'];
  addItems: (items: ICheckout['items']) => void;
  removeItems: (items: ICheckout['items']) => void;
  getTotal(withoutBump?: boolean): number;
  isCached: boolean;
  isOCB?: boolean;
  ocbData?: {
    customer: ICustomer;
    payments: any[];
  };
  disableOCB: () => void;
  isRecurrence: boolean;
  firstItem: ICheckoutItem;
  isForeigner: boolean;
  setForeignerMode: (enabled: boolean) => void;
  isFinancialResponsibleForeigner: boolean;
  setFinancialResponsibleForeignerMode: (enabled: boolean) => void;
  canChangeForeigner: boolean;
  paymentMethods: string[];
  setPaymentMethods: (methods: string[]) => void;
  isRefused: boolean;
  setRefused: (refused: boolean) => void;
  showTerms: boolean;
  setShowTerms: (show: boolean) => void;
  hasError: boolean;
  error: Error | null;
  forceSubmit: () => void;
  transaction?: ITransaction;
  setCanSignDocument: (can: boolean) => void;
  canSignDocument?: boolean;
  isDocumentSigned?: boolean;
  setDocumentSigned: (signed: boolean) => void;
  appliedCoupon?: ICoupon;
  setAppliedCoupon: (coupon?: ICoupon) => void;
  installments: ICheckoutInstallment[];
  setInstallments: (installments: ICheckoutInstallment[]) => void;
};

const FormContext = createContext<FormContext>({} as FormContext);

export function useForm() {
  const context = useContext(FormContext);

  if (context === undefined) {
    throw new Error('useFiltersContext must be used within a FiltersProvider');
  }

  return context;
}

const FormProvider = FormContext.Provider;

export default FormProvider;
